import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
export function HeroSection() {
  return <Section background="cream" className="overflow-hidden pt-8 md:pt-20" data-id="element-135">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-136">
        {/* Image Content - shows first on mobile */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="relative order-first lg:order-last" data-id="element-137">
          <div className="absolute inset-0 bg-[#52B788] rounded-3xl rotate-3 opacity-20 blur-xl transform scale-95" data-id="element-138"></div>
          <img src="https://cdn.magicpatterns.com/uploads/uh5Tz6rhdBpp5udQMsTKis/diabetes_mokup2.png" alt="Guía de recetas para diabetes en tablet" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-139" />
        </motion.div>

        {/* Text Content - shows second on mobile */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-5 md:space-y-8 order-last lg:order-first" data-id="element-140">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#52B788]/20 text-[#2D6A4F] text-sm font-medium mb-1" data-id="element-141">
            <Star className="w-4 h-4 mr-1 fill-current" data-id="element-142" />
            Guía práctica en español
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D6A4F] leading-tight tracking-tight" data-id="element-143">
            Deja de improvisar con la comida:{' '}
            <span className="text-[#BC6C25]" data-id="element-144">30 recetas</span> para prevenir y
            controlar la diabetes.
          </h1>

          <p className="text-base md:text-xl text-gray-700 leading-relaxed max-w-xl" data-id="element-145">
            Una guía clara para entender lo esencial y tener un plan práctico:
            qué priorizar, cómo cocinar y qué recetas usar en tu día a día para
            un mejor control glucémico.
          </p>

          <ul className="space-y-2 md:space-y-3" data-id="element-146">
            {['30 recetas pensadas para comidas reales (desayunos, platos y snacks)', 'Pautas simples de porciones, cocción y "carbohidratos inteligentes"', 'Consejos de hábitos: movimiento, sueño y estrés (sin complicaciones)', 'Sección de control/monitoreo: A1C, presión arterial y perfil lipídico'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} className="flex items-start text-gray-700" data-id="element-147">
                <div className="mt-1 mr-3 flex-shrink-0 bg-[#52B788] rounded-full p-0.5" data-id="element-148">
                  <Check className="w-3 h-3 text-white" data-id="element-149" />
                </div>
                <span data-id="element-150">{item}</span>
              </motion.li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-2" data-id="element-151">
            <div className="flex flex-col" data-id="element-152">
              <span className="text-gray-500 line-through text-sm" data-id="element-153">
                Antes 9,99 €
              </span>
              <span className="text-3xl font-bold text-[#BC6C25]" data-id="element-154">6,39 €</span>
            </div>
            <Button size="lg" withIcon className="w-full sm:w-auto" onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-155">
              Quiero la guía por 6,39 €
            </Button>
          </div>

          <p className="text-xs text-gray-500 italic" data-id="element-156">
            Descarga digital inmediata. Contenido educativo: no sustituye el
            consejo médico.
          </p>
        </motion.div>
      </div>
    </Section>;
}